import React from 'react';
import { Typography, Flex, QRCode, Button, Input, message } from 'antd';
import { CopyOutlined, ShareAltOutlined } from '@ant-design/icons';
import './DocumentProgressSteps.css';

const { Text } = Typography;

export function linkDisclaimerText(variant) {
  if (variant === 'estimate') {
    return 'Anyone with the link can view this estimate.';
  }
  if (variant === 'invoice') {
    return 'Anyone with the link can view this invoice.';
  }
  return 'Anyone with the link can view this page.';
}

/**
 * Share UI: link field, copy, QR. Use inside a modal or card.
 *
 * @param {boolean} showHeading — show icon + "Share" row (hide when modal already has title)
 */
const DocumentSharePanel = ({ variant, showHeading = true }) => {
  const pageUrl = typeof window !== 'undefined' ? window.location.href : '';

  const handleCopyLink = async () => {
    if (!pageUrl) {
      return;
    }
    try {
      await navigator.clipboard.writeText(pageUrl);
      message.success('Link copied to clipboard');
    } catch {
      message.error('Unable to copy. Please try again.');
    }
  };

  return (
    <div className="document-share-panel">
      <Flex vertical gap={14}>
        <div>
          {showHeading && (
            <Flex align="center" gap={8} className="document-share-card__heading">
              <ShareAltOutlined className="document-share-card__heading-icon" aria-hidden />
              <Text strong className="document-share-card__title">
                Share
              </Text>
            </Flex>
          )}
          <Text
            type="secondary"
            className={`document-share-card__lead${showHeading ? '' : ' document-share-card__lead--solo'}`}
          >
            {linkDisclaimerText(variant)}
          </Text>
        </div>

        <div className="document-share-card__field-wrap">
          <Input.TextArea
            readOnly
            variant="borderless"
            value={pageUrl}
            placeholder="—"
            autoSize={{ minRows: 2, maxRows: 5 }}
            className="document-share-card__input"
            aria-label="Page link"
            onFocus={(e) => e.target.select()}
          />
        </div>

        <Button
          type="primary"
          block
          icon={<CopyOutlined />}
          onClick={handleCopyLink}
          disabled={!pageUrl}
        >
          Copy link
        </Button>

        <div className="document-share-card__divider" aria-hidden>
          <span className="document-share-card__divider-text">or scan</span>
        </div>

        <div className="document-share-card__qr">
          <QRCode value={pageUrl || '-'} size={112} />
        </div>
      </Flex>
    </div>
  );
};

export default DocumentSharePanel;
